import { TemplatePage } from './types';

const backgroundVideoPage: TemplatePage = {
  header: {
    color: '#FCFCFC',
    icon: 'images/video-templates/background.jpg',
    title: 'Background Video Templates',
    title_meta: 'Free Background Video Templates',
    description_meta:
      'Explore a large collection of editable background video templates. Find the perfect video background. Try free!',
    description:
      'These video templates will make a perfect background for your talking head video, webinar promotion, product ' +
      'demo, or even a zoom call. Discover our expansive collection of video backgrounds: abstract, futuristic, modern, ' +
      'gradient, cute — find the one that fits your style. '
  },
  footer: {
    category: 'Background',
    description:
      'Do you want to make videos fast and easily? Try Wave.video templates! Every template is fully customizable so ' +
      'that you can replace the text, change the colors, upload your files and add your logo for brand recognition. Try ' +
      'it now!'
  },
  content: [
    {
      type: 'templates',
      title: 'background video',
      search: { name: 'background video' }
    },
    {
      type: 'stocks',
      title: 'Background video templates',
      search: { name: 'background video' }
    },
    { type: 'calendar' }
  ]
};

export default backgroundVideoPage;
